<template>

  <!-- Quiz Subjects Slider Content -->
  <div
    class="quiz-subjects-slider-content">

    <swiper
      ref="swiper"
      :options="swiperOptions"
      class="quiz-subjects-slider-content__swiper">

      <swiper-slide
        :key="item.id"
        v-for="item in items"
        class="quiz-subjects-slider-content__slide">

        <universal-link
          :to="`/quiz-subject/${item.slug}`">

          <quiz-subject-card
            :value="item"
            class="card-shadow hover-scale-2"/>

        </universal-link>

      </swiper-slide>

    </swiper>

  </div>

</template>

<script>

  import QuizSubjectCard from '@src/components/card/quiz-subject-card';

  export default {
    name: 'quiz-subjects-slider-content',
    props: {
      value: {
        type: Object,
        required: true,
      },
      items: {
        type: Array,
        default: () => [],
      },
    },
    components: {
      QuizSubjectCard,
    },
    data() {
      return {
        swiperOptions: {
          slidesPerView: 'auto',
          spaceBetween: 30,
        },
      };
    },
  };

</script>

<style lang="scss">

  .quiz-subjects-slider-content {
    color: inherit;

    &__swiper {
      overflow: visible;
    }

    &__slide {
      max-width: 350px;
    }
  }

</style>
